import {
  FETCH_HOME_STORIES_START,
  FETCH_HOME_STORIES_SUCCESS,
  FETCH_HOME_STORIES_FAILURE,
  FETCH_PROFILE_STORIES_START,
  FETCH_PROFILE_STORIES_SUCCESS,
  FETCH_PROFILE_STORIES_FAILURE,
  FETCH_STORY_START,
  FETCH_STORY_SUCCESS,
  FETCH_STORY_FAILURE,
  SAVE_STORY_START,
  SAVE_STORY_SUCCESS,
  SAVE_STORY_FAILURE,
  SAVE_FROM_POST_START,
  SAVE_FROM_POST_SUCCESS,
  SAVE_FROM_POST_FAILURE,
  UPDATE_STORY_DATA_STATUS_START,
  UPDATE_STORY_DATA_STATUS_SUCCESS,
  UPDATE_STORY_DATA_STATUS_FAILED,
  CLEAR_PROFILE_STORIES_START,
  DELETE_STORY_START,
  DELETE_STORY_SUCCESS,
  DELETE_STORY_FAILURE,
} from "../actions/ActionConstant";

export function saveStoryStart(data) {
  return {
    type: SAVE_STORY_START,
    data,
  };
}

export function saveStorySuccess(data) {
  return {
    type: SAVE_STORY_SUCCESS,
    data,
  };
}

export function saveStoryFailure(error) {
  return {
    type: SAVE_STORY_FAILURE,
    error,
  };
}

export function saveStoryFromPostStart(data) {
  return {
    type: SAVE_FROM_POST_START,
    data,
  }
}

export function saveStoryFromPostSuccess(data) {
  return {
    type: SAVE_FROM_POST_SUCCESS,
    data,
  }
}

export function saveStoryFromPostFailure(error) {
  return {
    type: SAVE_FROM_POST_FAILURE,
    error,
  }
}

export function fetchHomeStoriesStart(data) {
  return {
    type: FETCH_HOME_STORIES_START,
    data
  };
}

export function fetchHomeStoriesSuccess(data) {
  return {
    type: FETCH_HOME_STORIES_SUCCESS,
    data,
  };
}

export function fetchHomeStoriesFailure(error) {
  return {
    type: FETCH_HOME_STORIES_FAILURE,
    error,
  };
}

export function fetchProfileStoriesStart(data) {
  return {
    type: FETCH_PROFILE_STORIES_START,
    data
  }
}

export function fetchProfileStoriesSuccess(data) {
  return {
    type: FETCH_PROFILE_STORIES_SUCCESS,
    data
  }
}

export function fetchProfileStoriesFailure(error) {
  return {
    type: FETCH_PROFILE_STORIES_FAILURE,
    error
  }
}

export function fetchStoryStart(data) {
  return {
    type: FETCH_STORY_START,
    data
  }
}

export function fetchStorySuccess(data) {
  return {
    type: FETCH_STORY_SUCCESS,
    data
  }
}

export function fetchStoryFailure(error) {
  return {
    type: FETCH_STORY_FAILURE,
    error
  }
}

export function UpdateStoryDataStatus (data){
  return {
    type: UPDATE_STORY_DATA_STATUS_START,
    data
  }
}

export function UpdateStoryDataStatusSuccess (data){
  return {
    type: UPDATE_STORY_DATA_STATUS_SUCCESS,
    data
  }
}

export function UpdateStoryDataStatusFailure (error){
  return {
    type: UPDATE_STORY_DATA_STATUS_FAILED,
    error
  }
}

export function clearProfileStoriesStart() {
  return {
    type: CLEAR_PROFILE_STORIES_START,
  }
}

export function deleteStoryStart(data) {
  return {
    type: DELETE_STORY_START,
    data,
  };
}

export function deleteStorySuccess(data) {
  return {
    type: DELETE_STORY_SUCCESS,
    data,
  };
}

export function deleteStoryFailure(error) {
  return {
    type: DELETE_STORY_FAILURE,
    error,
  };
}
